// extracted by mini-css-extract-plugin
export default {"mc":"SkuDetailV2_mc__lxjsd","tips":"SkuDetailV2_tips__dpP2Q"};